import { getAlertsByCardId } from "@/api/alerts";
import { useQuery } from "@tanstack/react-query";

export function usePriceAlertsByCard(cardId: number) {
  return useQuery({
    queryKey: ["price-alerts", cardId],
    async queryFn() {
      return getAlertsByCardId(cardId);
    },
  });
}
